import { createAction } from '@reduxjs/toolkit'

const cmeInspectorActions = {
  fetch: createAction('FETCH_CME_INSPECT'),
  successLoad: createAction('SUCCESS_LOAAD_CME_INSPECT'),
  failedLoad: createAction('FAILED_LOAAD_CME_INSPECT')
}

export default cmeInspectorActions
